var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7f6c72ee14eae4abc209830ac5056764c23772ee"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["aloware-admin@aloware"]={id:"7f6c72ee14eae4abc209830ac5056764c23772ee"};
      